import { array, number, object, string } from 'yup';
import 'modules/bracket/validators';

export const tournamentMatchResultsValidationSchema = () => {
  return object().shape({
    results: array(
      object({
        matchGameId: string(),
        status: string(),
        results: array().of(
          object({
            status: string(),
            teamId: string().required(),
            score: number().max(1, 'Score must be less than or equal to 1').min(0).required(),
          }).uniqueMatchGameScore('score', 'Score should be unique')
        ),
      })
    ),
  });
};
